<app-header></app-header>

<div class="custom_scrollbar">
  <div>
    <section
      class="pt-5 d-table w-100"
      style="background: linear-gradient(180deg, #96c2dd, #ffffff 90%)"
    >
      <div class="container">
        <div
          class="row mt-5 align-items-center position-relative"
          style="z-index: 1; bottom: 4rem"
        >
          <div class="col-lg-6">
            <span class="badge bg-primary-subtle text-primary mb-3"
              ><i class="bi bi-broadcast"></i> Telecom</span
            >
            <div class="title-heading text-center text-lg-start">
              <h1
                class="fw-bold mb-3 mt-3"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                Real‑time AI for Telecom Sales & Service
              </h1>
              <p
                class="para-desc mx-auto mx-lg-start mb-0 ms-0"
                style="color: black"
              >
                <strong>ConnectNow</strong> transforms sales and service
                interactions with real‑time, AI‑driven virtual experiences. It
                seamlessly integrates multimodal AI (video, voice, and chat)
                with human interactions to boost connections and conversions. AI
                agents handle repetitive tasks, freeing humans to focus on sales
                and personalized service. Built for businesses of every size and
                sector, <strong>ConnectNow</strong> is intuitive, scalable, and
                ready for everyone.
                <br />
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="card border-0 shadow rounded ms-lg-4 overflow-hidden">
              <iframe
                class="iframe w-100 rounded"
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/e1OnUbxnHiw?si=-dnf1VonvC-aa_6v&amp;controls=1&rel=0&loop=1"
                title="YouTube video player"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                  web-share;
                "
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <section id="features" class="py-5">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="fw-bold">Key Features for Telecom</h2>
          <p class="text-secondary mb-0">
            Purpose‑built capabilities that improve conversion, reduce costs,
            and increase first‑contact resolution.
          </p>
        </div>
        <div class="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-4">
          <!-- Feature 1 -->
          <div class="col">
            <div class="card h-100 rounded-4 p-3">
              <div class="card-body">
                <div class="feature-icon bg-primary-subtle text-primary mb-3">
                  <i class="bi bi-robot"></i>
                </div>
                <h5 class="card-title">AI‑Powered Customer Support</h5>
                <p class="card-text text-secondary">
                  ConnectNow’s intelligent AI agents instantly handle common
                  telecom queries like billing, plan upgrades, and network
                  issues, reducing wait times and ensuring round-the-clock
                  assistance for customers.
                </p>
              </div>
            </div>
          </div>
          <!-- Feature 2 -->
          <div class="col">
            <div class="card h-100 rounded-4 p-3">
              <div class="card-body">
                <div class="feature-icon bg-success-subtle text-success mb-3">
                  <i class="bi bi-arrow-repeat"></i>
                </div>
                <h5 class="card-title">Seamless Human–AI Collaboration</h5>
                <p class="card-text text-secondary">
                  Routine inquiries are resolved by AI, while complex cases are
                  smoothly transitioned to human agents, ensuring customers
                  always receive accurate, personalized, and efficient support.
                </p>
              </div>
            </div>
          </div>
          <!-- Feature 3 -->
          <div class="col">
            <div class="card h-100 rounded-4 p-3">
              <div class="card-body">
                <div class="feature-icon bg-info-subtle text-info mb-3">
                  <i class="bi bi-collection-play"></i>
                </div>
                <h5 class="card-title">
                  Multimodal Engagement (Video, Voice, Chat)
                </h5>
                <p class="card-text text-secondary">
                  Customers can interact through video, voice, or chat, enabling
                  telecom companies to provide flexible, real-time support and
                  sales guidance across multiple channels.
                </p>
              </div>
            </div>
          </div>

          <!-- Feature 4 -->
          <div class="col">
            <div class="card h-100 rounded-4 p-3">
              <div class="card-body">
                <div class="feature-icon bg-warning-subtle text-warning mb-3">
                  <i class="bi bi-graph-up-arrow"></i>
                </div>
                <h5 class="card-title">
                  Scalable & Cost‑Effective Service Delivery
                </h5>
                <p class="card-text text-secondary">
                  Designed for businesses of all sizes, ConnectNow helps telecom
                  providers scale their support operations without adding extra
                  staff, lowering costs while enhancing customer satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <app-footer></app-footer>
  <div class="fix-ui">
    <app-fixed-call></app-fixed-call>
  </div>
</div>
